/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowStorytellingNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowStorytellingNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Share Your Stories!",
    "Let’s Tell Tales!",
    "Storytime Awaits!",
  ],
  title: "Storytelling Night",
  description: "Organize a fun storytelling night.",
  longDescription:
    "Gather your friends for an engaging storytelling night! Choose a date, decide on themes, and plan snacks for the evening!",
  emoji: "📖",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Storytelling Night",
          emoji: "📖",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the storytelling night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on storytelling themes?",
            description: "What themes should we explore in our stories?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What themes should we choose?",
                emoji: "🌌",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we enjoy during storytelling?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍿",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Share Our Tales!",
    outroDescription:
      "Your storytelling night plans are set! Enjoy the stories!",
  },
};
